import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFormatQuote$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFormatQuote extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '3eec5cf420e80642203a41d017070739566ce389', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ae1b14d5d2f96f55f0b41b53f9ba57d088ee7868', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '43b162d3d9c470315a5e376ef737b2f850459543', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.925 7.425A3.5 3.5 0 0 1 15.5 4a3.5 3.5 0 0 1 3.26 4.77l-3.61 9a.52.52 0 0 1-.44.25h-1.35a.5.5 0 0 1-.43-.75L15.35 11a3.5 3.5 0 0 1-3.425-3.575m-9 0A3.5 3.5 0 0 1 6.5 4 3.5 3.5 0 0 1 10 7.5c0 .428-.08.853-.24 1.25l-3.61 9a.52.52 0 0 1-.44.25H4.36a.5.5 0 0 1-.43-.75L6.35 11a3.5 3.5 0 0 1-3.425-3.575", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-format-quote", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-format-quote"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-format-quote":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFormatQuote$1);
            }
            break;
    } });
}

const CosmosIconFormatQuote = CosmosIconFormatQuote$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFormatQuote, defineCustomElement };
